<!--
 * @Description: 
 * @Date: 2021-07-29 23:18:58
-->
<template>
  <div class="group-img ">
    <div
      class="item"
      v-for="(item, index) in queryData.invoiceImgUrl"
      :key="index"
    >
      <el-image
        :src="item.invoicePic"
        :preview-src-list="queryData.invoiceImgUrl.map(i => i.invoicePic)"
      ></el-image>
      <div
        class="icon-box"
        v-if="!disabled"
        @click="
          () => {
            queryData.invoiceImgUrl.splice(index, 1);
          }
        "
      >
        <i class="el-icon-close"></i>
      </div>
      <el-input v-model="item.invoiceNo" :disabled="disabled" />
    </div>
    <UploadImgOne
      :ifDisable="disabled"
      ref="uploadImg"
      v-if="queryData.invoiceImgUrl.length < 5 && !disabled"
      class="invoice-upload-box"
      @upload-done="
        v => {
          coverPicDone(v);
        }
      "
      :noNeedDefaultImg="true"
      :placeWord="'上传'"
    ></UploadImgOne>
  </div>
</template>

<script>
import UploadImgOne from '@/components/Common/newUpLoadImgOne.vue';
export default {
  props: {
    disabled: [Boolean],
    info: {
      type: Object,
      default: () => {
        return {
          invoiceImgUrl: []
        };
      }
    }
  },
  components: {
    UploadImgOne
  },
  data() {
    return {
      queryData: {
        invoiceImgUrl: []
      }
    };
  },
  methods: {
    coverPicDone(v) {
      this.queryData.invoiceImgUrl.push({
        invoicePic: v,
        invoiceNo: ''
      });
      ((this.$refs || {})['uploadImg'] || {}).picUrl = '';
    }
  },
  created() {
    this.queryData = { ...this.info };
  },
  watch: {
    queryData: {
      handler(newV) {
        this.$emit('change', newV);
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
.group-img {
  margin-bottom: 20px;
  display: flex;
  align-items: flex-start;
  .name {
    width: 120px;
    text-align: right;
    font-weight: 800;
    color: rgba(51, 51, 51, 1);
    flex-shrink: 0;
    &.required {
      &::before {
        content: '*';
        color: #ef0000;
        font-size: 14px;
        margin-right: 5px;
      }
    }
  }
  .item {
    width: 174px;
    height: 162px;
    margin-left: 10px;
    .el-image {
      width: 100%;
      height: 112px;
      object-fit: cover;
    }
    position: relative;
    .icon-box {
      position: absolute;
      background: rgba($color: #000000, $alpha: 0.6);
      width: 30px;
      height: 30px;
      border-radius: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      right: 5px;
      top: 5px;
      cursor: pointer;
    }
  }
  .invoice-upload-box {
    width: 174px;
    height: 112px;
    margin-left: 10px;
  }
}
.part-1 {
  align-items: center;
  .item {
    height: 36px;
  }
}
</style>
